import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-hot-toast";
import { fetchApi } from "../apis/Index";
import SavedItem from "../components/Cart/SavedItem";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import { CartContextProvider } from "../context/CartContext";

const Saved = () => {
  const { savedItems, favError } = useContext(CartContextProvider);
  const [load, setLoad] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);

  useEffect(() => {
    if (savedItems) {
      setLoad(true);
      setLoadingComplete(true);
    }
  }, [savedItems]);

  useEffect(() => {
    if (favError) {
      toast.error(favError);
    }
  }, [favError]);

  const deleteSaved = async () => {
    const deleteSavedApi =
      "https://wittynailtip.com/backend/empty-fav.php";
    try {
      const result = await fetchApi(deleteSavedApi);
      if (result.data.success) {
        window.location.reload();
      } else {
        console.log(result.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validSavedItems = savedItems?.filter(
    (item) => !item.error && item.prices?.[0]?.unit_amount !== undefined,
  );

  return (
    <div className="font-jost min-h-screen bg-gray-50 pb-20">
      <ToastContainer position="bottom-center" autoClose={2000} />
      <Navbar />
      <div className="md:w-5/6 w-[90%] mx-auto mt-6 md:mt-10 h-full">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 px-2">Saved Items</h2>
        <div className="w-full space-y-4">
          {!loadingComplete ? (
            <Loader what={"Your saved items are"} />
          ) : validSavedItems?.length > 0 ? (
            validSavedItems.map((item) => (
              <div key={item.fav_id} className="bg-white rounded-2xl shadow-sm p-2 transition-shadow hover:shadow-md">
                <SavedItem
                  price={item.prices[0].unit_amount}
                  id={item.id}
                  info={item.description}
                  name={item.name}
                  color={item.color}
                  image={item.images?.[0]}
                  item={item}
                />
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-white rounded-3xl shadow-sm mt-4">
              <div className="w-24 h-24 bg-[#fff1f5] rounded-full flex items-center justify-center mb-6">
                <svg className="w-12 h-12 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">Your wishlist is empty</h2>
              <p className="text-gray-500 mb-8 max-w-md">
                {savedItems?.some((item) => item.error)
                  ? "We had trouble loading some items. Try refreshing."
                  : "Save your favorite nail sets here so you can easily find them later!"}
              </p>
              <Link to="/">
                <button className="bg-gray-900 hover:bg-black text-white px-8 py-3 rounded-full font-medium transition-all shadow-lg hover:-translate-y-1">
                  Explore Collections
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>
      {validSavedItems?.length > 0 && (
        <div className="cart-footer flex items-center w-full fixed bottom-0 h-auto min-h-[70px] py-3 bg-white/90 backdrop-blur-md border-t border-gray-100 shadow-[0_-10px_30px_rgba(0,0,0,0.05)] z-40">
          <div className="md:w-5/6 w-[90%] mx-auto flex items-center justify-end z-10">
            <button
              type="button"
              className="bg-red-50 hover:bg-red-100 text-red-600 font-medium flex justify-center items-center rounded-full cursor-pointer px-6 py-2 transition-colors"
              onClick={deleteSaved}
            >
              Clear All Saved Items
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Saved;
